import { render, staticRenderFns } from "./TargetGroupModal.vue?vue&type=template&id=71fcf2d0&scoped=true&"
import script from "./TargetGroupModal.vue?vue&type=script&lang=js&"
export * from "./TargetGroupModal.vue?vue&type=script&lang=js&"
import style0 from "./TargetGroupModal.vue?vue&type=style&index=0&id=71fcf2d0&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "71fcf2d0",
  null
  
)

export default component.exports